// extracted by mini-css-extract-plugin
module.exports = {"splashScreen":"splash-screen_splashScreen__hX-fo","splash":"splash-screen_splash__4rOFK"};